@if (objectForm) {
    <nz-spin [nzSpinning]="loading">
        <form nz-form [formGroup]="objectForm" class="login-form" nzLayout="vertical">
            <div nz-row [nzGutter]="[10, 5]">
                <div nz-col nzSpan="8" [nzLg]="8" [nzMd]="12" [nzSm]="24" [nzXs]="24">
                    <h3>Pamatdati</h3>
                    <nz-form-item>
                        <nz-form-label nzRequired nzFor="clientId">Klients</nz-form-label>
                        <nz-form-control clValidationError="clientId">
                            <cl-search-field-form-control
                                formControlName="clientId"
                                fieldPlaceholder="Klients"
                                [allowClear]="true"
                                [modelType]="EntityType.Client"
                            >
                            </cl-search-field-form-control>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label nzRequired nzFor="invoiceTypeId">Rēķina veids</nz-form-label>
                        <nz-form-control clValidationError="invoiceTypeId">
                            <nz-select nzShowSearch nzPlaceHolder="Rēķina veids" formControlName="invoiceTypeId">
                                @for (invoiceType of invoiceTypes$ | async; track invoiceType.id) {
                                    <nz-option [nzLabel]="invoiceType.description" [nzValue]="invoiceType.originalLuidaisId"></nz-option>
                                }
                            </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label nzRequired nzFor="number">Numurs</nz-form-label>
                        <nz-form-control nzHasFeedback [nzErrorTip]="numberErrorTip" nzValidatingTip="Pārbauda...">
                            <input type="text" nz-input formControlName="number" id="number" />
                            <ng-template #numberErrorTip let-control>
                                @if (control.hasError('duplicated')) {
                                    Rēķins ar šādu numuru jau eksistē
                                }
                                @if (control.hasError('duplicated')) {
                                    <br />
                                }
                                @if (control.hasError('required')) {
                                    Ievadlauks ir obligāts
                                }
                                @if (control.hasError('required')) {
                                    <br />
                                }
                                @if (control.hasError('maxlength')) {
                                    Vērtība nedrīkst būt garāka par {{ control.errors.maxlength.requiredLength }} simboliem. Vērības garums:
                                    {{ control.errors.maxlength.actualLength }}
                                }
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label nzRequired nzFor="date">Datums</nz-form-label>
                        <nz-form-control clValidationError="date">
                            <nz-date-picker
                                class="w-100"
                                id="date"
                                formControlName="date"
                                [nzFormat]="'dd.MM.yyyy'"
                                [nzPlaceHolder]="'Datums'"
                            ></nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label nzRequired nzFor="dateUntil">Samaksāt līdz</nz-form-label>
                        <nz-form-control clValidationError="dateUntil">
                            <nz-date-picker
                                class="w-100"
                                id="dateUntil"
                                formControlName="dateUntil"
                                [nzFormat]="'dd.MM.yyyy'"
                                [nzPlaceHolder]="'Samaksāt līdz'"
                            ></nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label nzFor="serviceDate">Pakalpojuma sniegšanas datums</nz-form-label>
                        <nz-form-control clValidationError="serviceDate">
                            <nz-date-picker
                                class="w-100"
                                id="serviceDate"
                                formControlName="serviceDate"
                                [nzFormat]="'dd.MM.yyyy'"
                                [nzPlaceHolder]="'Pakalpojuma sniegšanas datums'"
                            ></nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label nzFor="notes">Piezīmes</nz-form-label>
                        <nz-form-control clValidationError="notes">
                            <textarea rows="4" nz-input class="w-100" id="notes" formControlName="notes" placeholder="Piezīmes"></textarea>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzSpan="8" [nzLg]="8" [nzMd]="12" [nzSm]="24" [nzXs]="24">
                    <cl-invoice-sum-fields #invoiceSumFields [objectForm]="objectForm" [invoice]="originalObject"></cl-invoice-sum-fields>
                </div>
            </div>
            @if (!originalObject.isDeleted) {
                <div nz-row class="w-full table-container">
                    <cl-sinvoice-invoices-table
                        [sinvoice]="originalObject"
                        (sinvoiceChanged)="reloadData()"
                        class="w-full"
                    ></cl-sinvoice-invoices-table>
                </div>
            }
        </form>
        <div class="mt-3">
            @if (isEditMode) {
                <cl-info-button [id]="originalObject.id" class="mr-1" [entityType]="EntityType.Sinvoice" (loadingChanged)="loading = $event"></cl-info-button>
                <cl-notification-history-button
                    [entityType]="EntityType.Sinvoice"
                    [id]="originalObject.id"
                    class="ml-2 mr-3"
                ></cl-notification-history-button>
            }
            @if (!originalObject.isDeleted) {
                <button *hasPermission="[GroupPermission.MENU_BOOKKEEPER]" class="mr-4" nz-button nzDanger (click)="deleteSinvoice()">
                    <i nz-icon nzType="delete"></i>
                </button>
            } @else {
                <button
                    *hasPermission="[GroupPermission.MENU_BOOKKEEPER]"
                    nz-button
                    class="mr-3"
                    nzType="default"
                    [disabled]="loading"
                    (click)="restoreFromDeleted()"
                >
                    Izņemt no dzēstajiem
                </button>
            }
            <button nz-button class="mr-3" nzType="default" [disabled]="loading" (click)="cancel()">Atcelt</button>
            <button nz-button nzType="primary" (click)="validateAndSave()">Saglabāt</button>
        </div>
    </nz-spin>
}
